import { JSX, useEffect } from "react";

const MARKETO_BASE_URL = "https://go.questanalytics.com";
const MARKETO_MUNCHKIN_ID = "598-MKX-845";
const MARKETO_FORM_ID = 1716;

const QuinnLimitRequestInfo = (): JSX.Element => {
  const descriptionText = "To learn more about purchasing additional question allotment for Quinn, please complete this form.";

  /* oxlint-disable @typescript-eslint/no-explicit-any */
  useEffect(() => {
    const loadMarketoForm = () => {
      if (document.querySelector('script[src*="forms2.min.js"]')) {
        if ((window as any).MktoForms2) {
          (window as any).MktoForms2.loadForm(MARKETO_BASE_URL, MARKETO_MUNCHKIN_ID, MARKETO_FORM_ID);
        }
        return;
      }

      const script = document.createElement('script');
      script.src = `${MARKETO_BASE_URL}/js/forms2/js/forms2.min.js`;
      script.async = true;
      script.onload = () => {
        setTimeout(() => {
          if ((window as any).MktoForms2) {
            (window as any).MktoForms2.loadForm(MARKETO_BASE_URL, MARKETO_MUNCHKIN_ID, MARKETO_FORM_ID);
          }
        }, 100);
      };
      document.body.appendChild(script);
    };

    loadMarketoForm();
  }, []);
  /* oxlint-enable @typescript-eslint/no-explicit-any */

  return (
    <div className="ai-chat-panel__limit-request-info">
      <p>{descriptionText}</p>
      <div>
        <form id={`mktoForm_${MARKETO_FORM_ID}`}></form>
      </div>
    </div>
  );
};

export { QuinnLimitRequestInfo };
